import React from 'react';
import { Tooltip, Box, Typography } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

function TassSourceCitation({ citation }) {
  if (!citation) return null;

  const tooltipContent = (
    <Box sx={{ p: 0.5 }}>
      <Typography variant="caption" sx={{ fontWeight: 600 }}>
        {citation.label}
      </Typography>
      <Typography variant="caption" display="block" sx={{ opacity: 0.8 }}>
        {citation.dataType}
      </Typography>
    </Box>
  );

  return (
    <Tooltip title={tooltipContent} arrow placement="top">
      <InfoIcon
        sx={{
          fontSize: 14,
          color: 'info.main',
          cursor: 'pointer',
          verticalAlign: 'middle',
          mx: 0.25,
          '&:hover': { color: 'info.dark' }
        }}
      />
    </Tooltip>
  );
}

export default TassSourceCitation;
